"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function formatPostalCode(postalCode) {
    return ("" + postalCode).replace(/(...)/, "$1 ");
}
exports.default = formatPostalCode;
